import http from '@core/fetch'
import { API_SHOP_INFO } from '@constant'

export default {
  list: () => http('/p/wedding/Admin/APIMerchantWeappAdmin/AdminList'),

  unbind: body =>
    http.post('/p/wedding/Admin/APIMerchantWeappAdmin/Unbind', { body }),

  WXACodeUrlShare: body =>
    http('/p/wedding/Admin/APIMerchantWeappShare/WXACodeUrl', { body }),

  WXACodeUrl: body =>
    http('/p/wedding/Admin/APIMerchantWeapp/WXACodeUrl', { body }),

  freeOpen: body =>
    http.post('/p/wedding/Admin/APIMerchantWeappShare/FreeOpen', { body }),

  stat: () => http('/p/wedding/Admin/APIMerchantWeapp/Stat'),

  shopInfo: () => http(API_SHOP_INFO),

  auditInfo: () => http('/p/wedding/Admin/APIMerchantWeappVersion/AuditInfo')
}
